module.exports = __webpack_public_path__ + "static/media/message-sent.ffb26807.svg";